import {connect} from 'react-redux';
import {find} from 'lodash';
import EmptyHeader from 'shared/components/empty-header';
import switchAccount from 'shared/actions/switch-account';

const mapStateToProps = ({userConnections}) => {
  const impersonatedUser = find(
    userConnections,
    (connection) => connection.connectedUser.impersonatedUser
  );

  const originalUser = find(
    impersonatedUser ? impersonatedUser.userConnectionInfo : [],
    (user) => user.authenticated_user_id !== impersonatedUser.connectedUser._id
  );

  const impostorUserId = originalUser ? originalUser.authenticated_user_id : '';

  return {
    impostorUserId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  switchUser: (id) => dispatch(switchAccount(id, 'Exiting impostor mode from onboarding')),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmptyHeader);
